import { ObjectMapper } from 'json-object-mapper';

export class PermissionModel {
  userAccessClaimId: string = '';
  enable: boolean = false;
  userAccessClaimTitle: string = '';

  static create(input: any): PermissionModel {
    return ObjectMapper.deserialize<PermissionModel>(PermissionModel, input);
  }
}
